import { Divider } from "antd";
import classNames from "classnames/bind";
import styles from "./StreamCam.module.css";
import { ImageObject } from "../../../../components";
import { sizeImage } from "./ConfigFontSize";

const cx = classNames.bind(styles);
function ModalInfoEvent({ detail, screen, fullScreen }) {
    const className = fullScreen ? "font-size-fullsc-" : 'font-size-';
    const sizeImg = fullScreen ? sizeImage?.find(item => item.screen === screen).sizeFs : sizeImage?.find(item => item.screen === screen).size;
    
    return (
        <div className={cx('content-modal', `${className}${screen}`, (detail?.is_monitor) && 'is-monitor')} >
            {detail?.time || ""}
            <Divider className={cx('devider')} />
            {detail?.object === 'doituongla' ? 'unknow' : (detail?.object || "")}
            <Divider className={cx('devider')} />
            {detail?.info || ''}
            <Divider className={cx('devider')} />
            <ImageObject
                type="plate"
                src={detail?.image}
                maxWidth={240}
                height={sizeImg}
            />
        </div>
    )
}

export default ModalInfoEvent;